import * as Api from '@ViewModels';
import { isOlderThan30Days } from './emailFiltering';

/**
 * Checks if a social media post should be hidden based on cancelled status criteria
 * @param post - The social media post to check
 * @param isExplicitlyCancelledFilter - Whether the user has explicitly selected "Cancelled" filter
 * @returns true if the post should be hidden, false otherwise
 */
export function shouldHideCancelledSocialPost(
	post: Api.ISocialMediaPostReport,
	isExplicitlyCancelledFilter = false
): boolean {
	// If user explicitly selected "Cancelled" filter, show all cancelled posts
	if (isExplicitlyCancelledFilter) {
		return false;
	}

	// Only apply hiding logic to cancelled posts
	if (post.status !== Api.PostStatus.Cancelled) {
		return false;
	}

	// For social posts, we use the cancellation date to determine if it's older than 30 days
	// This is more accurate than creation date for cancelled items
	return isOlderThan30Days(post.cancelledDate);
}

/**
 * Filters out social media posts that should be hidden based on cancelled status criteria
 * @param posts - Array of posts to filter
 * @param isExplicitlyCancelledFilter - Whether the user has explicitly selected "Cancelled" filter
 * @returns Filtered array of posts
 */
export function filterCancelledSocialPosts(
	posts: Api.ISocialMediaPostReport[],
	isExplicitlyCancelledFilter = false
): Api.ISocialMediaPostReport[] {
	return posts.filter(post => !shouldHideCancelledSocialPost(post, isExplicitlyCancelledFilter));
}
